// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"266":"dec249e9","791":"11275300"}[chunkId] + ".js";
};